import React from 'react';

import {
  Typography,
  DescriptionList,
  DescriptionItem,
} from '@gogame/components';

import {
  CALCULATION_TYPE,
  METRIC_VALUE_TYPE,
  VALUE,
  WEIGHTED_AVERAGE,
  PERCENT,
  OPERATOR,
  AFFECTED_LEVEL_PART_HELPERS,
  NAME,
} from 'scenes/SmartRules/SmartRuleForm/Conditions';
import {
  AFFECTED_LEVEL,
  SECONDARY_AFFECTED_LEVEL,
} from 'scenes/SmartRules/SmartRuleForm/General';
import {
  useFormatValue,
  PERCENT as FORMAT_PERCENT,
  NUMBER as FORMAT_NUMBER,
} from 'scenes/SmartRules/hooks';

const OPERATOR_PART_HELPERS = {
  higher: 'of highest',
  lower: 'of lowest',
};

export const RunResults = ({ data }) => {
  const formatValue = useFormatValue();

  if (
    !(
      data.affectedEntitiesCount ||
      data.inspectedEntitiesCount ||
      data.thresholdSkippedCount
    )
  ) {
    return <Typography>No items matched the rule conditions</Typography>;
  }

  return (
    <DescriptionList data={data} stripEmpty={true} disableGutters={true}>
      <DescriptionItem
        field={'affectedEntitiesCount'}
        label={'Meets'}
        type={({ value }) => (
          <Typography>{formatValue(value, FORMAT_NUMBER)}</Typography>
        )}
      />

      <DescriptionItem
        field={'inspectedEntitiesCount'}
        label={'Inspected'}
        type={({ value }) => (
          <Typography>{formatValue(value, FORMAT_NUMBER)}</Typography>
        )}
      />

      <DescriptionItem
        field={'thresholdSkippedCount'}
        label={'Skipped'}
        type={({ value }) => (
          <Typography>{formatValue(value, FORMAT_NUMBER)}</Typography>
        )}
      />

      {data?.processingResult?.dynamicMetrics?.length
        ? data.processingResult.dynamicMetrics.map(
            ({
              [CALCULATION_TYPE]: calculationType,
              [VALUE]: value,
              [METRIC_VALUE_TYPE]: metricValueType,
              [NAME]: metricName,
              [PERCENT]: percent,
              [OPERATOR]: operator,
            }) => {
              if (calculationType === WEIGHTED_AVERAGE) {
                return (
                  <DescriptionItem
                    value={value}
                    key={metricName}
                    label={'Calc. threshold weighted average'}
                    type={({ value }) => (
                      <Typography>
                        {formatValue(value, FORMAT_NUMBER)}
                      </Typography>
                    )}
                  />
                );
              }

              const {
                [AFFECTED_LEVEL]: affectedLevelId,
                [SECONDARY_AFFECTED_LEVEL]: secondaryAffectedLevelId,
              } = data.processingResult.dynamicTarget;

              const operatorHelper = OPERATOR_PART_HELPERS[operator];
              const affectedHelper =
                AFFECTED_LEVEL_PART_HELPERS[
                  secondaryAffectedLevelId || affectedLevelId
                ];

              return (
                <DescriptionItem
                  value={value}
                  key={metricName}
                  label={'Calc. threshold'}
                  type={({ value }) => (
                    <Typography>{`${formatValue(
                      percent,
                      FORMAT_PERCENT
                    )} ${operatorHelper} ${metricName} ${affectedHelper}: ${formatValue(
                      value,
                      metricValueType
                    )}`}</Typography>
                  )}
                />
              );
            }
          )
        : null}
    </DescriptionList>
  );
};
